/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WebhooksService {
    /**
     * @returns any
     * @throws ApiError
     */
    public static webhooksControllerHandleRevenueCatV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/webhooks/revenuecat',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static webhooksControllerHandleStripeV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/webhooks/stripe',
        });
    }
}
